import request from '@/utils/request';

/**
 * 店铺列表
 */
export function offlineStoreList(params) {
  return request({
    url: '/admin/offlineStore/list',
    method: 'GET',
    params: params
  });
}

/**
 * 店铺选择列表
 */
export function offlineUserStoreList(params) {
  return request({
    url: '/admin/system/admin/offlineUser/autoList',
    method: 'GET',
    params: params
  });
}

/**
 * 添加店铺
 */
export function offlineUserStoreSave(data) {
  return request({
    url: '/admin/offlineStore/saveOrUpdate',
    method: 'post',
    data: data
  });
}

/**
 * 删除店铺
 */
export function offlineStoreDelete(params) {
  return request({
    url: '/admin/offlineStore/delete',
    method: 'GET',
    params: params
  });
}

// 员工列表
/**
 * 员工列表
 */
export function fflineEmployee(params) {
  return request({
    url: '/admin/offlineEmployee/list',
    method: 'GET',
    params: params
  });
}

/**
 * 删除员工
 */
export function fflineEmpDelete(params) {
  return request({
    url: '/admin/offlineEmployee/delete',
    method: 'GET',
    params: params
  });
}

/**
 * 获取角色列表
 */
export function fflineEmpGetRoleList(params) {
  return request({
    url: '/admin/offlineEmployee/getRoleList',
    method: 'GET',
    params: params
  });
}

/**
 * 添加员工
 */
export function fflineEmpGetSave(data) {
  return request({
    url: '/admin/offlineEmployee/save',
    method: 'post',
    data: data
  });
}

/**
 * 重置员工密码
 */
export function fflineEmpGetreSetPassword(params) {
  return request({
    url: '/admin/offlineEmployee/resetPassword',
    method: 'GET',
    params: params
  });
}

/**
 * 状态修改
 */
export function fflineEmpGetreSetStatus(params) {
  return request({
    url: '/admin/offlineEmployee/setStatus',
    method: 'GET',
    params: params
  });
}

/**
 * 编辑员工
 */
export function fflineEmpGetreSetUpdate(data) {
  return request({
    url: '/admin/offlineEmployee/update',
    method: 'POST',
    data: data
  });
}

/**
 * 导入店铺
 */
export function fflineEmpGetreSetImport(formData) {
  return request({
    url: "/admin/offlineStore/import",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 * 导入员工
 */
export function fflineEmpGetreSetImportUser(formData) {
  return request({
    url: "/admin/offlineEmployee/import",
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}